module.exports = __webpack_public_path__ + "static/media/profile-img-edit.849c29fe.webp";